import { PostgrestClient } from "@supabase/postgrest-js";
import * as React from "react";
import { useLocalStorage } from "react-use";
import { useFunctionQueue } from "../hooks/usePostgresQueue";
import { getPostgrestUrl } from "../utils";
import { AIRPLX_TOKEN, useIdentity } from "./IdentityContainer";
import { createContainer } from "./StateContainer";

type Props = {
  children?: React.ReactNode;
};

/**
 */
const useApiContainerState = () => {
  const { airplxToken } = useIdentity();
  const [token] = useLocalStorage(AIRPLX_TOKEN, "", { raw: true });
  const queue = useFunctionQueue();

  const postgrest = React.useMemo(() => {
    const tokenToUse = token || airplxToken;

    // Don't create authenticated client without valid token
    // This prevents RLS errors when requests are made before auth is ready
    if (!tokenToUse) {
      return null;
    }

    const cli = new PostgrestClient(getPostgrestUrl());
    cli.auth(tokenToUse);
    return cli;
  }, [token, airplxToken]);

  // TODO
  return {
    postgrest,
    queue,
    helpers: {
      deleteTenant: async (tenantId: string) => {
        if (!postgrest) {
          throw new Error("Cannot delete tenant: not authenticated");
        }
        return postgrest.from("tenant").delete().eq("id", tenantId);
      },
    },
  };
};

const ApiContainerState = createContainer(useApiContainerState);

/**
 * Set up an identity container scope. This should really only be in the
 * application once -- and way way up at the root.
 */
export const ApiContainer: React.FC<Props> = ({ children }) => {
  return <ApiContainerState.Provider>{children}</ApiContainerState.Provider>;
};

/**
 * Hook into the current identity context.
 */
export const useApi = ApiContainerState.useContainer;
